//TODO trocar nome de acordo com a linguagem selecionada

export const AllLanguages = [
    {
        id: 1,
        title: "Português",
        flag: "br",
        locale: "pt-BR",
    },
    {
        id: 2,
        title: "Inglês",
        flag: "us",
        locale: "en-US",
    },
    {
        id: 3,
        title: "Espanhol",
        flag: "es",
        locale: "es-ES",
    },
    {
        id: 4,
        title: "Italiano",
        flag: "it",
        locale: "it-IT",
    },
];
